/**
 * @file The Not Found component.
 * @author Heino Lenting
 */
import { OnInit } from '@angular/core';
var NotFoundComponent = /** @class */ (function () {
    function NotFoundComponent() {
    }
    NotFoundComponent.prototype.ngOnInit = function () {
    };
    return NotFoundComponent;
}());
export { NotFoundComponent };
